import { CellContext } from '@tanstack/react-table'

import { BusStop, Log, LogLocationType, MandatoryLogInformation, MileageLossCode, RouteBusStops } from '@/types/logs'
import { MissingInfo } from './MissingInfo'

import styles from './Location.module.scss'

interface Props
    extends CellContext<
        Log,
        { locationTo: string; locationFrom: string; locationType: LogLocationType; direction: string }
    > {
    getRouteBusStops: (route?: string | undefined) => '' | RouteBusStops | undefined
    allStopsData: BusStop[]
}

export const LocationUnfinished = ({ getValue, row }: Props) => {
    const { locationTo, locationFrom } = getValue()

    const isDefaultLocationOption = !(row.original.code && row.original.code in MileageLossCode)

    if (isDefaultLocationOption) {
        return locationFrom ? (
            <p>{locationFrom}</p>
        ) : (
            <MissingInfo log={row.original} label="location" field={MandatoryLogInformation.LocationFrom} />
        )
    }

    return (
        <div className={styles.root}>
            <div className={styles.container}>
                <div className={styles.info}>
                    {locationFrom ? (
                        <>
                            <span className={styles.label}>From:</span>{' '}
                            <span className={styles.text}>{locationFrom}</span>
                        </>
                    ) : (
                        <MissingInfo log={row.original} label="from" field={MandatoryLogInformation.LocationFrom} />
                    )}
                </div>
                <div className={styles.info}>
                    {locationTo ? (
                        <>
                            <span className={styles.label}>To:</span> <span className={styles.text}>{locationTo}</span>
                        </>
                    ) : (
                        <MissingInfo log={row.original} label="to" field={MandatoryLogInformation.LocationTo} />
                    )}
                </div>
            </div>
        </div>
    )
}
